import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

const ErrorMessage = ({ message }) => {
    if (!message) return null;

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            style={{
                backgroundColor: '#ffecec',
                color: '#d32f2f',
                border: '1px solid #d32f2f',
                borderRadius: '8px',
                padding: '16px',
                marginTop: '20px',
                fontSize: '1rem',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            }}
        >
            <Box
                style={{
                    fontWeight: 'bold',
                    fontSize: '1.2rem',
                    marginBottom: '8px',
                }}
            >
                Oops!
            </Box>
            <Box style={{ textAlign: 'center' }}>
                {message}
            </Box>
        </Box>
    );
};

ErrorMessage.propTypes = {
    message: PropTypes.string,
};

ErrorMessage.defaultProps = {
    message: '',
};

export default ErrorMessage;